import { render } from "./SaveCandidate.vue?vue&type=template&id=235bef90&scoped=true"
import script from "./SaveCandidate.vue?vue&type=script&lang=js"
export * from "./SaveCandidate.vue?vue&type=script&lang=js"

import "./SaveCandidate.vue?vue&type=style&index=0&id=235bef90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235bef90"]])

export default __exports__